// extracted by mini-css-extract-plugin
export var container = "Container-module--container--3bdec";
export var full = "Container-module--full--8e3c9";
export var wide = "Container-module--wide--a1f47";